import {Component, Input, OnInit} from "@angular/core";
import {Website} from "../../website";
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {SecurityIssue} from "../security-issue";
import {SecurityService} from "../security.service";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {SecurityFileDiff} from "../security-file-diff";
import * as fromStore from '../../../../store';
import {Store} from "@ngrx/store";
import {UserSubscription, UserSubscriptionType} from '../../../../user/user-subscription';
import {filter, first, switchMap} from 'rxjs/operators';
import {Utils} from '../../../../shared/utils/utils';
import {Config} from '../../../../config/config';
import {Router} from "@angular/router";

export interface IRestoreSecurityIssueDialogData {
  website: Website;
  securityIssue: SecurityIssue;
}
@Component({
    selector: 'db-restore-security-issue-dialog',
    templateUrl: './restore-security-issue-dialog.component.html',
    styleUrls: ['./restore-security-issue-dialog.component.scss'],
    standalone: false
})
export class RestoreSecurityIssueDialogComponent extends DialogComponent<IRestoreSecurityIssueDialogData, null> implements OnInit, IRestoreSecurityIssueDialogData {

  @Input() website: Website;
  @Input() securityIssue: SecurityIssue;

  public loading: boolean;
  public restoring: boolean;

  private _userSubscriptions: UserSubscription[];
  private _currentSubscription: UserSubscription;
  public securityFileDiff: SecurityFileDiff;

  public canPreview: boolean;
  public _childWebsiteId: number;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _router: Router,
    private _securityService: SecurityService
  ) {
    super(
      _dialogService
    );
  }

  public ngOnInit(): void {
    this._childWebsiteId = this.website.isNetwork && !this.website.parentId && this.website.children && this.website.children.length ? this.website.children[0] : null;

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserAvailableSubscriptions())),
        first()
      )
      .subscribe((userAvailableSubscriptions: UserSubscription[]) => {
        this._userSubscriptions = userAvailableSubscriptions;
      });

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        this._currentSubscription = userSubscription;
      });

    const fileExtension: string = Utils.getExtension(this.securityIssue.fileName);
    this.canPreview = Config.diffPreviewExtensions.includes(fileExtension);

    this.loadData();
  }

  public loadData(): void {
    this.loading = true;
    this._securityService.getFileDiff(this._childWebsiteId || this.website.id, this.securityIssue)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.securityFileDiff = response.data;
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          this.close();
        }
      });
  }

  public restore(): void {
    if (this._currentSubscription.type === UserSubscriptionType.FREE || this._currentSubscription.type === UserSubscriptionType.ONE_PRODUCT) {
      this.serviceUpgrade();
      return;
    }

    this.restoring = true;

    this._securityService.restoreFile(this._childWebsiteId || this.website.id, this.securityIssue)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.restoring = false;

        if (response.success) {
          this._store.dispatch(new fromStore.RestoreSecurityFile({
            websiteId: this._childWebsiteId || this.website.id
          }));

          this.close();
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  public serviceUpgrade() {
    this.close();
    this._router.navigate(['/upgrade-plan'], { queryParams: { active_tab: 'platform' } });
  }

}
